export default "__VITE_ASSET__CH3tlPS6__"